import React from 'react';
import { useTranslation } from 'react-i18next';

import { ThemeManager } from '../../../../themes/theme-manager';
import { Hyperlink } from '../../../hyperlink/hyperlink';
import { InfoBox } from '../../../info-box/info-box';
import { Stack } from '../../../stack/stack';

export const ImageThresholdExceededInfoBox = () => {
  const { t } = useTranslation();
  return (
    <InfoBox color="yellow" leftIcon={{ icon: 'info-circle' }}>
      <Stack spacing={1}>
        {t('setupDialog.imageCountExceededInfo', { ns: 'cloudProcessing' })}
        <Hyperlink
          target="_blank"
          url={ThemeManager.instance.getCloudProcessingTermsOfServiceUrl()}
        >
          {t('setupDialog.termsOfServiceCloudProcessing', { ns: 'cloudProcessing' })}
        </Hyperlink>
      </Stack>
    </InfoBox>
  );
};
